"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LessonNode = void 0;
const BasicFunction_1 = require("./BasicFunction");
const ExecutableItem_1 = require("./ExecutableItem");
const ExecutionGroup_1 = require("./ExecutionGroup");
const Guard_1 = require("./Guard");
const Help_1 = require("./Help");
class LessonNode extends ExecutableItem_1.ExecutableItem {
    constructor(node, extras) {
        var _a;
        super();
        this.extras = extras;
        this.executableType = ExecutableItem_1.ExecutableType.LessonNode;
        this.name = node.name;
        this.id = node.id;
        this.refId = node.id;
        this.maxErrorsAllowed = node.maxErrorsAllowed;
        this.guards = Guard_1.Guard.arrayFactory(node.guards || []);
        this.help = (node.help || []).map((help) => new Help_1.Help(help, this.extras));
        if (((_a = node.function) === null || _a === void 0 ? void 0 : _a.class) === ExecutableItem_1.ExecutableType.ExecutionGroup) {
            this.executable = new ExecutionGroup_1.ExecutionGroup(node.function, this.extras);
        }
        else {
            this.executable = new BasicFunction_1.BasicFunction(node.function, this.extras);
        }
    }
    isFirstNodeASystemAction() {
        return this.executable.isFirstNodeASystemAction();
    }
    isComplete() {
        return this.executable.isComplete();
    }
    isNodeInProgress() {
        return this.executable.isNodeInProgress();
    }
    getHelp() {
        return this.help.map((help) => help.getHelpVal());
    }
    reset() {
        this.executable.reset();
    }
    validate(val) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.executable.validate(val);
        });
    }
    getSystemAction() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.hasMoreSystemActions()) {
                const action = yield this.executable.getSystemAction();
                if (this.executable.isComplete()) {
                    this.markComplete();
                }
                return action;
            }
            return {
                skipped: true,
                result: null,
            };
        });
    }
    consumeGuardFailingNodes() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.executable.consumeGuardFailingNodes();
        });
    }
    hasMoreSystemActions() {
        if (this.isComplete()) {
            return false;
        }
        return this.executable.hasMoreSystemActions();
    }
    // @depricated
    getNextAction() {
        if (this.executable.executableType === ExecutableItem_1.ExecutableType.BasicFunction) {
            const basicFuctin = this.executable;
            return {
                isCompleted: true,
                val: basicFuctin.getValToEmit(),
            };
        }
        else {
            const result = this.executable.getNextAction();
            console.log('lessonNode result', result);
            return result;
        }
    }
}
exports.LessonNode = LessonNode;
//# sourceMappingURL=data:application/json;base64,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